// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"114":"aitools","594":"about"}[chunkId] || chunkId) + "." + {"114":"21838d51","594":"550a85c2","653":"d7528942"}[chunkId] + ".js";
};